module.exports = __webpack_public_path__ + "img/icon_card017.e138470e.png";